import axios from 'axios'

function initialState() {
  return {
    flags: [],
  }
}

const ADD_FLAG = 'ADD_FLAG'
const SET_FLAGS = 'SET_FLAGS'
const DELETE_FLAG = 'DELETE_FLAG'
const UPDATE_FLAG = 'UPDATE_FLAG'
const RESET = 'RESET'

const BASE_URL = 'api/Flags'
const ADMIN_BASE_URL = 'api/Admin/Flags'
const GET_FLAGS__BY_TENANT_URL = (tenantId) => `${BASE_URL}/${tenantId}`
const ADD_FLAG_URL = `${ADMIN_BASE_URL}/Add`
const UPDATE_FLAG_URL = `${ADMIN_BASE_URL}/Update`
const DELETE_FLAG_URL = `${ADMIN_BASE_URL}/Remove`

export default {
  namespaced: true,
  state: initialState,
  actions: {
    async getFlagsByTenant({
      commit,
    }, tenantId) {
      try {
        let res = await axios.get(GET_FLAGS__BY_TENANT_URL(tenantId))
        commit(SET_FLAGS, res.data)
      } catch (error) {
        console.error(error)
        throw error
      }
    },
    async addFlag({
      commit,
    }, options) {
      try {
        let res = await axios.post(ADD_FLAG_URL, options.data)
        commit(ADD_FLAG, res.data)
        options.successCb()
      } catch (err) {
        console.error(err)
        options.failedCb(err)
        throw err
      }
    },
    async editFlag({
      commit,
    }, options) {
      try {
        let res = await axios.put(UPDATE_FLAG_URL, options.data)
        commit(UPDATE_FLAG, res.data)
        options.successCb()
      } catch (err) {
        console.error(err)
        options.failedCb(err)
        throw err
      }
    },
    async deleteFlag({
      commit,
    }, options) {
      try {
        let res = await axios.delete(DELETE_FLAG_URL, {
          data: options.data,
        })

        commit(DELETE_FLAG, res.data)
        options.successCb()
      } catch (err) {
        console.error(err)
        options.failedCb(err)
        throw err
      }
    },
  },
  mutations: {
    [RESET](state) {
      const s = initialState()
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    },
    [SET_FLAGS](state, data) {
      state.flags = data
    },
    [ADD_FLAG](state, data) {
      var dc = JSON.parse(JSON.stringify(state.flags))
      dc.push(data)
      state.flags = dc
    },
    [UPDATE_FLAG](state, data) {
      var dc = JSON.parse(JSON.stringify(state.flags))
      dc.forEach(e => {
        if (e.Id == data.Id) {
          e.FlagCode = data.FlagCode
          e.Description = data.Description
          e.ShowValues = data.ShowValues
          e.TenantId = data.TenantId
        }
      })
      state.flags = dc
    },
    [DELETE_FLAG](state, data) {
      var dc = JSON.parse(JSON.stringify(state.flags))
      let deldata = dc.find(e => e.Id == data.Id)
      dc.splice(dc.indexOf(deldata), 1)
      state.flags = dc
    },
  },
  getters: {
    flags: s => s.flags,
  },
}